import React from 'react';
import './OptionNotes.css';

export interface OptionNote {
  /** 화면 번호 */
  option_number: number;
  is_correct: boolean;
  note: string;
}

interface Props {
  notes: OptionNote[];
  userAnswers?: number[];
  options?: Array<{ option_number: number; option_text: string }>;
}

/** 보기별 해설: 보기를 섞어도 설명이 그 보기를 따라가도록 보기마다 붙여 보여 줍니다. */
const OptionNotes: React.FC<Props> = ({ notes, userAnswers = [], options = [] }) => (
  <ol className="option-notes" aria-label="보기별 해설">
    {notes.map((item) => {
      const picked = userAnswers.includes(item.option_number);
      const optionText = options.find((option) => option.option_number === item.option_number)?.option_text;
      return (
        <li
          key={item.option_number}
          className={`option-notes__item ${item.is_correct ? 'is-correct' : ''} ${picked && !item.is_correct ? 'is-wrong-pick' : ''}`}
        >
          <div className="option-notes__head">
            <span className="option-notes__no">{item.option_number}</span>
            <span className="option-notes__verdict">{item.is_correct ? '정답' : '오답'}</span>
            {picked && <span className="option-notes__picked">내 선택</span>}
            {optionText && <span className="option-notes__text">{optionText}</span>}
          </div>
          {item.note && <p>{item.note}</p>}
        </li>
      );
    })}
  </ol>
);

export default OptionNotes;
